import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  getAdminOpenItemsListApi,
  addAdminOpenItemsApi,
  getAdminOpenItemsSingleApi,
  getClientOpenItemsListApi,
  updateAdminOpenItemsApi,
  uploadClientOpenItemsApi,
  getAllOpenItemCommentsApi,
  addOpenItemCommentApi,
  updateStatusAdminOpenItemsApi,
  sendOpenItemEmailApi,
} from "@/apis/openItemsApis";

import type {
  AddOpenItemPayload,
  GetClientOpenItemsListingPayload,
  GetAdminOpenItemsListingPayload,
  UploadOpenItemsPayload,
  GetAllOpenItemCommentsPayload,
  AddOpenItemCommentPayload,
  SendOpenItemEmailPayload,
} from "@/commonTypes/openItemsTypes";

// Open Items Actions - Admin
export const getAdminOpenItemsListAction = createAsyncThunk(
  "open-item/list",
  async (data: GetAdminOpenItemsListingPayload) => {
    const response = await getAdminOpenItemsListApi(data);
    return response.data;
  }
);

export const addAdminOpenItemsAction = createAsyncThunk(
  `open-item/add`,
  async (data: AddOpenItemPayload) => {
    const response = await addAdminOpenItemsApi(data);
    return response.data;
  }
);
export const updateAdminOpenItemsAction = createAsyncThunk(
  `open-item/update`,
  async (data: any) => {
    const response = await updateAdminOpenItemsApi(data);
    return response.data;
  }
);

export const updateStatusAdminOpenItemsAction = createAsyncThunk(
  `open-item/items-approval`,
  async (data: any) => {
    const response = await updateStatusAdminOpenItemsApi(data);
    return response.data;
  }
);

export const sendOpenItemEmailAction = createAsyncThunk(
  `open-item/sendEmail`,
  async (data: SendOpenItemEmailPayload) => {
    const response = await sendOpenItemEmailApi(data);
    return response.data;
  }
);

// Open Items Actions - Client
export const getClientOpenItemsListAction = createAsyncThunk(
  "open-item-client/list",
  async (data: GetClientOpenItemsListingPayload) => {
    const response = await getClientOpenItemsListApi(data);
    return response.data;
  }
);

export const uploadClientOpenItemsAction = createAsyncThunk(
  "open-item-client/upload",
  async (data: UploadOpenItemsPayload) => {
    const response = await uploadClientOpenItemsApi(data);
    return response.data;
  }
);

// Open Item Actions - Others
export const getAdminOpenItemsSingleAction = createAsyncThunk(
  `open-item`,
  async (data: any) => {
    const response = await getAdminOpenItemsSingleApi(data);
    return response.data;
  }
);

export const getAllOpenItemCommentsAction = createAsyncThunk(
  "open-item/getAllComments",
  async (data: GetAllOpenItemCommentsPayload) => {
    const response = await getAllOpenItemCommentsApi(data);
    return response.data;
  }
);

export const addOpenItemCommentsAction = createAsyncThunk(
  "open-item/addComments",
  async (data: AddOpenItemCommentPayload) => {
    const response = await addOpenItemCommentApi(data);
    return response.data;
  }
);
